"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Semicolon = void 0;
exports.usePrevious = usePrevious;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _value = require("./value");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "render", "color", "value", "className", "show", "highlightUpdates", "quotes", "style"];
function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}
var Semicolon = function Semicolon(_ref) {
  var children = _ref.children,
    render = _ref.render,
    color = _ref.color,
    value = _ref.value,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'w-rjv-object-key' : _ref$className,
    show = _ref.show,
    highlightUpdates = _ref.highlightUpdates,
    quotes = _ref.quotes,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var prevValue = usePrevious(value);
  var highlightContainer = (0, _react.useRef)(null);
  var isHighlight = (0, _react.useMemo)(function () {
    if (!highlightUpdates || prevValue === undefined) return false;
    // highlight if value type changed
    if ((0, _typeof2["default"])(value) !== (0, _typeof2["default"])(prevValue)) {
      return true;
    }
    if (typeof value === 'number') {
      // notice: NaN !== NaN
      if (isNaN(value) && isNaN(prevValue)) return false;
      return value !== prevValue;
    }
    // highlight if isArray changed
    if (Array.isArray(value) !== Array.isArray(prevValue)) {
      return true;
    }
    // not highlight object/function
    // deep compare they will be slow
    if ((0, _typeof2["default"])(value) === 'object' || typeof value === 'function') {
      return false;
    }

    // highlight if not equal
    if (value !== prevValue) {
      return true;
    }
    return false;
  }, [highlightUpdates, value]);
  (0, _react.useEffect)(function () {
    if (highlightContainer.current && isHighlight && 'animate' in highlightContainer.current) {
      highlightContainer.current.animate([{
        backgroundColor: 'var(--w-rjv-update-color, #ebcb8b)'
      }, {
        backgroundColor: ''
      }], {
        duration: 1000,
        easing: 'ease-in'
      });
    }
  }, [isHighlight, value]);
  var content = show ? "".concat(quotes).concat(children).concat(quotes) : children;
  if (render) return render((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: className
  }, props), {}, {
    value: value,
    style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, style), {}, {
      color: color
    }),
    children: content
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Label, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: className,
    color: color
  }, props), {}, {
    ref: highlightContainer,
    children: content
  }));
};
exports.Semicolon = Semicolon;